// src/services/dashboardService.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';


const getAuthHeaders = (walletAddress) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (walletAddress) {
    headers['x-wallet-address'] = walletAddress; 
  }
  return headers;
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch (e) {
      errorData = { message: response.statusText || `HTTP error! status: ${response.status}` };
    }
    console.error("API Error Response:", errorData);
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  if (response.status === 204) { // No Content
    return null;
  }
  return response.json();
};


export const getDashboardStats = async (walletAddress) => {
  if (!walletAddress) {
    return Promise.reject(new Error("Wallet address is required to fetch dashboard stats."));
  }
  console.log(`[API Call] Fetching dashboard stats for: ${walletAddress}`);
  try {
    const response = await fetch(`${API_BASE_URL}/statistics/user-summary`, {
      method: 'GET',
      headers: getAuthHeaders(walletAddress),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching dashboard stats:", error.message);

    throw error;
  }
};


export const getDailyAgentActivityChartData = async (walletAddress) => {
  if (!walletAddress) {
    return Promise.reject(new Error("Wallet address is required for chart data."));
  }
  console.log(`[API Call] Fetching daily agent activity chart data for: ${walletAddress}`);
  try {
    const response = await fetch(`${API_BASE_URL}/statistics/daily-agent-activity`, { 
      method: 'GET',
      headers: getAuthHeaders(walletAddress),
    });
    console.log("Response:", response);
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching daily agent activity chart data:", error.message);

    throw error;
  }
};


export const getRecentActivities = async (walletAddress, limit = 5) => {
  if (!walletAddress) {
    return Promise.reject(new Error("Wallet address is required to fetch recent activities."));
  }
  console.log(`[API Call] Fetching recent activities for: ${walletAddress}, limit: ${limit}`);
  try {
    const response = await fetch(`${API_BASE_URL}/activities/recent?limit=${limit}`, {
      method: 'GET',
      headers: getAuthHeaders(walletAddress),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching recent activities:", error.message);
 
    throw error;
  }
};